"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutPreview() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="about-preview" className="relative bg-[hsl(40,30%,94%)] py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={textRef} className="space-y-6 transition-all duration-[150ms] ease-out" style={{
          opacity: textVisible ? 1 : 0,
          transform: textVisible ? "translateY(0)" : "translateY(12px)"
        }}>
            <div className="space-y-4">
              <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground tracking-tight">
                Welcome to EquiCanine
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                At EquiCanine, we specialize in providing comprehensive care for both horses and dogs. Our dedicated team ensures that every animal receives personalized attention in a safe, nurturing environment.
              </p>
              <p className="text-base text-muted-foreground leading-relaxed">
                Located in our spacious rural facility, we combine state-of-the-art stables with secure kennels to create the perfect home away from home for your beloved companions.
              </p>
            </div>
          </div>

          {}
          <div ref={imageRef} className="relative transition-all duration-[150ms] ease-out" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateX(0)" : "translateX(24px)"
        }}>
            <div className="relative w-full aspect-[4/3] overflow-hidden" style={{
            clipPath: "path('M 0,50 Q 0,0 50,0 Q 100,0 100,50 Q 100,100 50,100 Q 30,100 20,85 Q 10,70 0,50 Z')",
            clipPath: "polygon(0% 15%, 10% 0%, 40% 0%, 70% 5%, 90% 0%, 100% 10%, 100% 40%, 95% 70%, 100% 90%, 90% 100%, 60% 100%, 30% 95%, 10% 100%, 0% 85%, 0% 50%)"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542870/img/staff_caring_for_animals.png" alt="EquiCanine staff interacting with horses and dogs" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}